import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve } from '@angular/router';
import { pickPageMeta } from './seo-config.data';
import { PageMeta } from './seo-config.types';

@Injectable({ providedIn: 'root' })
export class PageMetaResolver implements Resolve<PageMeta | null> {
  constructor() {}

  resolve(route: ActivatedRouteSnapshot): PageMeta | null {
    const cityPath = route.paramMap.get('city');
    const featurePath = route.paramMap.get('feature');

    if (!featurePath) return null;

    const meta = pickPageMeta({ cityPath, featurePath });
    if (!meta) {
      return null;
    }
    return meta;
  }
}
